module.exports = __webpack_public_path__ + "static/mdk_logo-dbcfc6f18260dbb862d1054190f5d4f1.png";